module.exports = __webpack_public_path__ + "static/progetto_panoramicalliving3-406f9a8ec261c36603c6518c153240ff.jpg";